import React, { useEffect, useState } from "react";
// import { getData, postData } from "../../Service/ApiMethod";
// import { RECURITER_APPLICANTS, vaccancy_url } from "../../Service/service";
import AddToList from "./AddToList";
import ApplicantsDetails from "./ApplicantsDetails";
import RoundsPopup from "../home/component/RoundsPopup";
import { useTranslation } from "react-i18next";
import { lang } from "../../lang";

const Applicants = (props) => {
  // const [hire, setHire] = useState();
  const [ln,setLn] = useState('en')
  const [addtolistPopupp, setAddtolistPopupp] = useState(false);
  const [blackScreen, setBlackScreen] = useState(false)
  const [applicantIndexing, setApplicantIndexing] = useState()
  const [addToListIndexing, setAddToListIndexing] = useState()
  const [roundIndexing, setRoundIndexing] = useState()
  const [roundPopup,  setRoundPopup] = useState(false)
  


  const applicants_details = props?.applicants_details
  const setUpdateOnUnlock = props?.setUpdateOnUnlock
  const updateOnUnlock = props?.updateOnUnlock


  console.log("applicantxzz", props?.applicants_details)

useEffect(()=>{
  if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
},[])

  // const handleClick = () => {
  //   console.log();
  //   let dataObj = {
  //     vacancy_id: 59,
  //   };
  //   postData(dataObj, RECURITER_APPLICANTS)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setHire(data.data?.applicants_details);
  //       console.log('Applicant Data',data.data);
  //     })
  //     .catch((err) => {
  //       console.log("Error in categories from Post Form", err);
  //       console.log(" code Error", err);
  //     });
  // };

  // useEffect(() => {
  //   handleClick();
  // }, []);

  // console.log('hire', hire);
  const {t} = useTranslation();


  return (
    <>
      {applicants_details?.length != 0
        ? applicants_details?.map((item, index) => {
          return (
            <div
              className="col-lg-4 col-md-4 col-sm-6 col-12"
              id={item?.id}
              key={index}
              onClick={(e) => {
                e.stopPropagation()
                setBlackScreen(true)
                setApplicantIndexing(index)
              }}
            >
              <div className="recommended-profile">
                <div className="row">
                  <div className="col-lg-4 col-md-12 col-sm-12  px-0 " >
                    <div className="unlocked-profile-boxx relative flex-center " style={{margin:'0 auto',width:'100px',height:'100px',position:'relative'}}>
                    {item?.is_premium &&
                      <div className="premium-tag" style={{position:'absolute',left:'0',zIndex: '999',bottom:'30px'}}>
                        <img
                          src="../images/premium-tag.png"
                          className="premium-tag"
                          // title="Call"
                          alt=""
                        />
                      </div>
                    }
                    <div className="profile-img-box">
                    <img src={item?.applicant_profile_pic} alt="" className="profile-img" />
                    {/* <div className="save-profile-outer" style={{}} onClick={(e)=>{
                                e.stopPropagation()
                                setRoundPopup(true)
                                setRoundIndexing(index)
                                  
                                }}>
                                    <img className="call-imgg" src="../images/save-profile.png" alt="hellooo"  />
                                </div> */}
                    </div>
                    </div>
                    {/* <img
                        src="./images/save-profile.png"
                        alt=""
                        className="save-profile"
                        style={{ cursor: "pointer" }}
                      /> */}
                    {/* {props.bottom} */}
             
                  </div>
                
                  <div className="col-lg-8 col-md-12 col-sm-12 pr-0">
                    <h2 className="card-heding relative">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation()
                          props.openDetailPopup()
                        }}
                      >
                        {item?.applicant_name}
                      </span>
                      <img className="send-job addprofile"
                        src="../images/send-job.png"
                        alt=""
                       
                        onClick={(e) => {
                          e.stopPropagation()
                          setAddtolistPopupp(true);
                          setAddToListIndexing(index)
                        }}
                        style={{ }}
                      />
                      {/* {item?.applicant_details[0]?.is_verified ? (
                          <>
                            <img src="../images/verified.png" alt="" />
                            <span className="verified">Verified</span>
                          </>
                        ) : null} */}
                    </h2>
                    <p className="designation">{item?.vacancy_name}</p>
                    {(parseInt(item?.availability)) > 0 &&
                      <p className="profile-availbility">
                        ({t('Available')} {item?.availability})
                      </p>
                    }

                    <div className="row mt-2">
                      <div className="col-6 px-0">
                        <p className="card-subHeading">{t('Total Experience')}</p>
                        <p className="card-subHeading">{t('Current Location')}</p>
                        {/* <p className="card-subHeading">{t('Package')}</p> */}
                        <p className="horizontal-center">
                          <img
                            src="../images/match-badge.png"
                            className="img-size18"
                            alt=""
                          />
                          <span className="ms-1 match-profile">
                            {parseInt(item?.percentage_match)}% {t('Match')}
                          </span>
                        </p>
                      </div>
                      <div className="col-6 px-0">
                        <p className="profile-info">
                          {item?.experience_name} {item?.experience_name > 1 ? lang && Object.keys(lang).length > 0 ? lang[ln]?.MyListsScreen['Years']:"" : lang && Object.keys(lang).length > 0 ? lang[ln]?.MyListsScreen['Year']:""}
                        </p>
                        <p className="profile-info">
                          {parseInt(item?.distance)} {t('KM Away')}
                        </p>
                        {/* <p className="profile-info">
                          {item?.currency} {item?.expected_salary} {item?.compensation_details}{' '}
                        </p> */}
                        <p className="profile-last-seen">
                          <span className="last-seen">{t('Last Seen')}</span>
                          {item?.last_active} {t('ago')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {(applicantIndexing == index) && blackScreen &&
                <div className='blur-screen-full-area flex-center ' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', overflow: 'auto', background: 'rgb(0, 0, 0, 0.7' }} >
                  <ApplicantsDetails single_applicants_details={item} setBlackScreen={setBlackScreen} setUpdateOnUnlock={setUpdateOnUnlock} updateOnUnlock={updateOnUnlock} />
                </div>
              }
              {addtolistPopupp &&
                <AddToList setAddtolistPopupp={setAddtolistPopupp} seekerID={item?.applicant_id} />
              }
               {roundPopup  &&  (roundIndexing == index) &&
                    <RoundsPopup seekerID={item?.applicant_id} setRoundPopup={setRoundPopup}  />
                }
            </div>
          );
        })
        : <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', marginTop: '70px', color: 'grey', fontSize: '20px', marginBottom: '70px' }}>{t('No Data Found')}</div>}

    </>
  );
};

export default Applicants;
